// extracted by mini-css-extract-plugin
module.exports = {"header":"article-header_header__8GZ__"};